import React, { Component } from 'react'
import { Typography, withStyles, Box, Grid, Card, CardActionArea, CardContent, CardMedia, CardActions, Button} from "@material-ui/core";
import Switch from '@material-ui/core/Switch';
import CreateItem from './CreateItem'

const styles = theme => ({
    paper: {
        padding: 20,
        margin: theme.spacing(2),
    },
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(2),
    },
})

class MenuItem extends Component{

    constructor(props) {
        super(props)

        this.state = {
            open: false
        }
    }

    handleClick = () => {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        const { classes, item} = this.props
        return (
            <Grid key={item.id} item xs={12} sm={6} ml={4} style={{maxWidth: 300}}>
            {/* <Paper> */}
                <Card className={classes.root}>
                    <CardActionArea>
                        <CardMedia
                            src={item.imageUrl}
                            component="img"
                        />
                    <CardContent>
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <Typography component="h5">
                                    {item.name}
                                </Typography>
                            </Box>
                            {/* <Box>
                                <Typography color="textSecondary" align="right" component="h4">
                                    {"₹" + item.amount}
                                </Typography>
                            </Box> */}
                        </Box>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {item.time}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                <CardActions>
                    <Switch style={{ marginLeft: 'auto' }} checked={item.visible} onChange={() => { this.props.handleVisibleItemClick(item.id, item.visible) }} />
                    <CreateItem editMode={true} item={item}></CreateItem>
                    <Button size="small" color="secondary" onClick={() => { this.props.handleDeleteItemClick(item.id) }}>
                        Delete
                    </Button>       
                </CardActions>
                </Card>
            {/* </Paper> */}
            </Grid>
        )
    }
}

export default withStyles(styles)(MenuItem) 



    // < List component = "div" disablePadding >
    // {
    //     items.map((item) => {
    //         return (
    //             <ListItem button className={classes.nested} key={item.id} onClick={() => this.props.handleItemClick(item)} >
    //                 <ListItemText primary={item.name} />
    //                 <ListItemSecondaryAction>
    //                     <IconButton color="disabled" size="small" edge="end" style={{ marginRight: 10 }} onClick={() => { this.props.handleDeleteItemClick(item.id) }}>
    //                         <EditIcon />
    //                     </IconButton>

    //                     <IconButton color="secondary" size="small" edge="end" onClick={() => { this.props.handleDeleteItemClick(item.id) }}>
    //                         <DeleteIcon />
    //                     </IconButton>
    //                 </ListItemSecondaryAction>
    //             </ListItem>

    //             // <Note noteContent={note.noteContent} noteID={note.id} deleteNote={this.deleteNote} key={note.id}></Note>
    //         )
    //     })
    // }
    //                 </List >